/**
 * Onboarding steps helpers – single source of truth for step keys and completion.
 * Step value can be boolean or { completed: boolean }.
 */

/** Step keys and their fallbacks in onboarding steps object. */
export const ONBOARDING_STEP_KEYS = {
  step1: ['step1_organization_structure', 'facility_locations'],
  step3: ['step3_cleaning_standards'],
};

/**
 * Returns whether a step is completed from steps object.
 * @param {Object} steps - onboardingData.steps
 * @param {'step1'|'step3'} key
 * @returns {boolean}
 */
export function isOnboardingStepCompleted(steps, key) {
  const keys = ONBOARDING_STEP_KEYS[key];
  const value = keys?.reduce((acc, k) => acc ?? steps?.[k], undefined);
  return typeof value === 'boolean' ? value : value?.completed === true;
}

/**
 * Extracts steps object from onboarding status (API may return status.steps or status.data.steps).
 * @param {Object|null} onboardingStatus
 * @returns {Object}
 */
export function getStepsFromOnboardingStatus(onboardingStatus) {
  return onboardingStatus?.steps ?? onboardingStatus?.data?.steps ?? {};
}
